import React from "react";
import { 
    Stepper, 
    Step, 
    StepButton, 
    Button, 
    Snackbar,
    Box
} from '@mui/material';
import GeneralEventOptions from '../../components/administration/EditEvent/GeneralEventOptions'
import Prices from '../../components/administration/EditEvent/Prices'
import Options from '../../components/administration/EditEvent/Options'
import Registrations from '../../components/administration/EditEvent/Registrations'
import EmailModal from '../../components/administration/EditEvent/EmailModal'
import Accounting from '../../components/administration/EditEvent/Accounting'
import EventModel from '../../models/Events'
import RestUtilities, { IRestResponse } from '../../services/RestUtilities';
import EventStatus from '../../models/EventStatus';
import MemberGenderTypes from '../../models/MemberGenderTypes'
import BmwEventNumbers from '../../models/BmwEventNumbers';
import EventOptionAvailabilityTypes from '../../models/EventOptionAvailabilityTypes'
import MemberGroupTypes from '../../models/MemberGroupTypes';
import EventPriceDefinitions from '../../models/EventPriceDefinitions'
import MemberAgeGroups from '../../models/MemberAgeGroups';
import EventOptions from '../../models/EventOptions';
import EventAdditionalPriceDefinitions from '../../models/EventAdditionalPriceDefinitions'
import EventAdditonalPriceTypes from '../../models/EventAdditionalPriceType'
import Bookings from '../../models/Bookings'
import EventCosts from '../../models/EventCosts'
//import * as FileSaver from 'file-saver'
import { RoutePaths } from '../../components/Routes';
import Loader from '../../components/Loader';
import { GrowMessage } from "../../components/GrowMessage";
import { withRouter } from "../../components/Shared/withNavigate";
import Auth from "../../stores/Auth";

class FilterPriceDefinitions {
    memberGroupId: number
    availabilityTypeId: number
    memberAgeGroupId: number
    eventOptionId: number
    price: number
    [key: string]: any
}

class FilterAdditionalPriceDefinitions {
    memberGroupId: number
    memberAgeGroupId: number
    eventAdditionalPriceTypeId: number
    price: number
    [key: string]: any
}

class EditEvent extends React.Component<any, any> {

    public static FirstStep: string = 'Allgemein'
    public static SecondStep: string = 'Preise'
    public static ThirdStep: string = 'Optionen'
    public static FourthStep: string = 'Anmeldungen'
    public static FifthStep: string = 'Abrechnung' 

    constructor(props: any) {
        super(props)

        const params = new URLSearchParams(this.props.router.location.search)
        const eventId = params.get('eventid')

        if(eventId !== null)
            this.eventId = parseInt(eventId)
    }

    eventId: number
    state = {
        activeStep: 0,
        showPriceModal: false,
        showOptionsModal: false,
        showCostModal: false,
        event: new EventModel(),
        genderTypes: [] as MemberGenderTypes[],
        bmwNumbers: [] as BmwEventNumbers[],
        statuses: [] as EventStatus[],
        groupTypes: [] as MemberGroupTypes[],
        eventOptionAvailabilityTypes: [] as EventOptionAvailabilityTypes[],
        priceDefinitions: [] as EventPriceDefinitions[],
        newPriceDefinition: new EventPriceDefinitions(),
        newAdditionalPriceDefinition: new EventAdditionalPriceDefinitions(),
        ageGroups: [] as MemberAgeGroups[],
        eventOptions: [] as EventOptions[],
        filterPriceDefinition: new FilterPriceDefinitions(),
        filterAdditionalPriceDefinitions: new FilterAdditionalPriceDefinitions(),
        additionalPriceDefinitions: [] as EventAdditionalPriceDefinitions[],
        eventAdditionalPriceTypes: [] as EventAdditonalPriceTypes[],
        methodPrice: 'Submit',
        methodAdditionalPrice: 'Submit',
        bookings: [] as Bookings[],
        newCost: new EventCosts(),
        eventCosts: [] as EventCosts[],
        methodEventCost: 'Submit',
        showError: false,
        errorMessage: '',
        loading: false,
        showCancelModal: false,
        showEmailModal: false,
        emailText: '',
        showWarningModal: false,
        eventRequiredFields: {
            'eventStatusId': true,
            'eventName': true,
            'eventFrom': true,
            'eventTo': true,
            'bmweventNumberId': true
        },
        priceDefRequiredFields: {
            'memberAgeGroupId': true,
            'memberGroupTypeId': true,
            'eventOptionId': true,
            'availabilityId': true,
            'priceValue': true
        },
        additionalPriceDefiRequiredFields: {
            'eventAdditionalPriceTypeId': true,
            'priceValue': true,
        },
        eventCostsRequiredFields: {
            'expenditureAmount': true,
            'expenditureDescription': true
        },
        saveButtonDisabled: false,
        priceValues: [] as number[],
        additionalPriceValues: [] as number[]
    }

    handleChangeEventField = (event: any) => {
        const newModel: EventModel = {...this.state.event}

        newModel[event.target.name] = event.target.value

        let requiredFields = Object.keys(this.state.eventRequiredFields)

        if(requiredFields.findIndex(x => x === event.target.name) >= 0)
            this.validateEvent(newModel)
        
        this.setState({ event: newModel })
    }

    getSteps = (): string[] => {
        return [
            EditEvent.FirstStep,
            EditEvent.SecondStep,
            EditEvent.ThirdStep,
            EditEvent.FourthStep,
            EditEvent.FifthStep
        ]
    }

    getStepContent = (index: number): JSX.Element => {
        switch (index) {
            case 0:
                return <GeneralEventOptions 
                            value={this.state.event} 
                            statuses={this.state.statuses}
                            genderTypes={this.state.genderTypes}
                            bmwNumbers={this.state.bmwNumbers}
                            change={this.handleChangeEventField}
                            changeAttachment={this.handleChangeEventAttachment}
                            deleteTempAttachment={this.deleteTempAttachment}
                            downloadAttachment={this.downloadAttachment}
                            deleteAttachment={this.deleteAttachment}
                            eventRequiredFields={this.state.eventRequiredFields}
                            availabilityTypes={this.state.eventOptionAvailabilityTypes}
                            showCancelModal={this.showCancelModal}
                            showEmailModal={this.showEmailModal}
                            role={this.props.role}
                            generateInvoice={this.generateInvoice}
                            switchSaveButton={this.switchSaveButton}
                            export={this.exportPricesAndOptions}></GeneralEventOptions>
            case 1:
                return <Prices
                            modal={this.state.showPriceModal}
                            hideModal={this.hideModal}
                            showModal={this.showPriceModal}
                            availabilityTypes={this.state.eventOptionAvailabilityTypes}
                            groupTypes={this.state.groupTypes}
                            fetch={this.fetchPriceDefinitions}
                            fetchAgeGroups={this.fetchMemberAgeGroups}
                            fetchEventOptions={this.fetchEventOptions}
                            eventOptions={this.state.eventOptions}
                            ageGroups={this.state.ageGroups}
                            changeNewObject={this.handleChangeNewEventPrice}
                            newObject={this.state.newPriceDefinition}
                            submit={this.submitPriceDefinition}
                            priceDefinitions={this.state.priceDefinitions}
                            filter={this.state.filterPriceDefinition}
                            handleChangeFilter={this.handleChangeFilterPriceDefinition}
                            delete={this.deletePriceDefinition}
                            clearFilter={this.clearPriceDefinitionFilter}
                            changeMethod={this.changePriceMethod}
                            changeObject={this.changePriceDefinitionObject}
                            priceDefRequiredFields={this.state.priceDefRequiredFields}
                            method={this.state.methodPrice}
                            priceValues={this.state.priceValues}
                        >
                        </Prices>
            case 2:
                return <Options
                            modal={this.state.showOptionsModal}
                            fetch={this.fetchAdditionalPriceDefinitions}
                            showModal={this.showOptionsModal}
                            hideModal={this.hideOptionsModal}
                            ageGroups={this.state.ageGroups}
                            groupTypes={this.state.groupTypes}
                            eventAdditionalPriceTypes={this.state.eventAdditionalPriceTypes}
                            fetchPriceTypes={this.fetchEventAdditionalPriceTypes}
                            fetchAgeGroups={this.fetchMemberAgeGroups}
                            change={this.handleChangeNewEventAdditionalPrice}
                            newObject={this.state.newAdditionalPriceDefinition}
                            submit={this.submitAdditionalPriceDefinition}
                            additionalPriceDefinitions={this.state.additionalPriceDefinitions}
                            delete={this.deleteAdditionalPriceDefinition}
                            changeMethod={this.changeAdditionalPriceMethod}
                            changeObject={this.changeAdditionalPriceDefinitionObject}
                            validRequiredFields={this.state.additionalPriceDefiRequiredFields}
                            method={this.state.methodAdditionalPrice}
                            filter={this.state.filterAdditionalPriceDefinitions}
                            handleChangeFilter={this.handleChangeFilterAdditionalPriceDefinition}
                            clearFilter={this.clearAdditionalPriceDefinitionFilter}
                            priceValues={this.state.additionalPriceValues}
                            >
                        </Options>
            case 3:
                return <Registrations
                            {...this.props}
                            fetch={this.fetchBookings}
                            bookings={this.state.bookings}
                            eventId={this.state.event.id}
                            delete={this.deleteBooking}
                            showWarningModal={this.state.showWarningModal}
                            showWarningModalFunc={this.showWarningModal}
                            hideWaringModal={this.hideWaringModal}>
                        </Registrations>
            case 4:
                return <Accounting
                            modal={this.state.showCostModal}
                            showModal={this.showCostModal}
                            hideModal={this.hideCostModal}
                            fetchBookings={this.fetchBookings}
                            fetchCosts={this.fetchEventCosts}
                            bookings={this.state.bookings}
                            newCost={this.state.newCost}
                            changeNewCost={this.handleChangeEventCost}
                            costs={this.state.eventCosts}
                            submit={this.submitEventCost}
                            delete={this.deleteEventCost}
                            changeNewCostObject={this.changeNewCost}
                            changeMethod={this.changeEventCostMethod}
                            validRequiredFields={this.state.eventCostsRequiredFields}
                            ></Accounting>
            default:
                return <></>
        }
    }

    handleNext = (): void => {
        const { activeStep } = this.state
        const steps: string[] = this.getSteps()

        if(this.state.saveButtonDisabled)
            return
        if(activeStep === 0 ) {
            if(typeof this.state.event.id !== 'undefined')
                this.editEvent()
                    .then((data) => {
                        if(data){
                            this.setState({ activeStep: activeStep + 1 })
                        }
                    })
            else
                this.sumbitEvent()
                    .then((data) => {
                        if(data){
                            this.setState({ activeStep: activeStep + 1 })
                        }
                    })

        } else {
            this.setState({ activeStep: activeStep + 1 })
        }

        if(activeStep === steps.length - 1) {
            this.props.router.navigate(`${RoutePaths.AdminEvents}`)
        }
    }

    handleBack = (): void => {
        const { activeStep } = this.state
        this.setState({ activeStep: activeStep - 1 })
    }

    handleStep = (index: number): void => {
        const { activeStep } = this.state

        if(this.state.saveButtonDisabled)
            return

        //check if we are editting existing event
        const params = new URLSearchParams(this.props.router.location.search)
        const eventId = params.get('eventid')


        if (eventId !== null) {

            if (activeStep === 0) {
                this.editEvent()
                    .then(() => {
                        this.setState({ activeStep: index })
                    })
                } else {
                    this.setState({ activeStep: index })
                }
        }
    }

    showPriceModal = (): void => {
        this.setState({ showPriceModal: true })
    }
    
    hideModal = (): void => {
        this.setState({ showPriceModal: false, newPriceDefinition: new EventPriceDefinitions() })
    }

    showOptionsModal = (): void => {
        this.setState({ showOptionsModal: true })
    }

    hideOptionsModal = (): void => {
        this.setState({ showOptionsModal: false, newAdditionalPriceDefinition: new EventAdditionalPriceDefinitions() })
    }

    showCostModal = (): void => {
        this.setState({ showCostModal: true })
    }

    hideCostModal = (): void => {
        this.setState({ showCostModal: false, newCost: new EventCosts() })
    }

    showWarningModal = (): void => {
        this.setState({ showWarningModal: true })
    }

    hideWaringModal = (): void => {
        this.setState({ showWarningModal: false })
    }

    switchSaveButton = (disable: boolean) => {
        console.log('switchSaveButton', disable)
        if (disable !== this.state.saveButtonDisabled)
            this.setState((state: any) => ({
                saveButtonDisabled: disable
            }))
    }

    handleChangeNewEventPrice = (event: any): void => {
        const newModel = {...this.state.newPriceDefinition} as EventPriceDefinitions
        newModel[event.target.name] = event.target.value
        this.validatePriceDefinition(newModel)
        this.setState({ newPriceDefinition: newModel })
    }

    deleteTempAttachment = () => { 
         const newEvent = {...this.state.event}
         newEvent.attachment = null
        this.setState({ event: newEvent })
    }

    handleChangeEventAttachment = (event: any): void => {
        const newAttachment = {...this.state.event.attachment}
        const file = event.target.files[0]
        if(!file) {
            return;
        }
        let fileReader = new FileReader()
        fileReader.onloadend = () => {
            const newAttachment = {...this.state.event.attachment}
            
            newAttachment.eventId = this.state.event.id
            newAttachment.attachmentData = btoa(fileReader.result as string)
            newAttachment.attachmentFilename = file.name
            newAttachment.attachmentMimeType = file.type
            newAttachment.attachmentDescription = file.name
            newAttachment.id = 0

            const newEvent = {...this.state.event}
            newEvent.attachment = newAttachment

            this.setState({ event: newEvent })
        }
        fileReader.readAsBinaryString(file)
    }

    handleChangeNewEventAdditionalPrice = (event: any): void => {
        const newModel = {...this.state.newAdditionalPriceDefinition} as EventAdditionalPriceDefinitions

        newModel[event.target.name] = event.target.value

        this.validateAdditionalPriceDefinition(newModel)

        this.setState({ newAdditionalPriceDefinition: newModel })
    }

    handleChangeFilterPriceDefinition = (event: any): void => {
        const newFilter = {...this.state.filterPriceDefinition}

        newFilter[event.target.name] = event.target.value
        this.setState({ filterPriceDefinition: newFilter })
    }

    handleChangeFilterAdditionalPriceDefinition = (event: any): void => {
        const newFilter = {...this.state.filterAdditionalPriceDefinitions}

        newFilter[event.target.name] = event.target.value
        this.setState({ filterAdditionalPriceDefinitions: newFilter })
    }

    handleChangeEventCost = (event: any) => {
        const newCost = {...this.state.newCost}

        const field = event.target.name
        newCost[field] = event.target.value

        this.validateEventCost(newCost)

        this.setState({ newCost: newCost })
    }

    changeNewCost = (cost: EventCosts): void => {
        this.setState({ newCost: cost })
    }

    changeEventCostMethod = (method: string): void => {
        this.setState({ methodEventCost: method })
    }

    clearPriceDefinitionFilter = ():void => {
        this.setState({ filterPriceDefinition: new FilterPriceDefinitions() })
        this.fetchPriceDefinitions()
    }

    clearAdditionalPriceDefinitionFilter = (): void => {
        this.setState({ filterAdditionalPriceDefinitions: new FilterAdditionalPriceDefinitions() })
        this.fetchAdditionalPriceDefinitions()
    }

    changePriceMethod = (method: string): void => {
        this.setState({ methodPrice: method })
    }

    changePriceDefinitionObject = (object: EventPriceDefinitions): void => {
        this.setState({ newPriceDefinition: object })
    }

    changeAdditionalPriceMethod = (method: string): void => {
        this.setState({ methodAdditionalPrice: method })
    }

    changeAdditionalPriceDefinitionObject = (object: EventAdditionalPriceDefinitions): void => {
        this.setState({ newAdditionalPriceDefinition: object })
    }
 
    fetchEventStatuses = (): void => {
        RestUtilities.get<EventStatus[]>('/api/EventStatus')
        .then(resp => {
            let statuses: EventStatus[] = resp.content as EventStatus[]
            this.setState({ statuses: statuses })
        })
        .catch(resp => {
            this.showError(resp)
        })
    }

    fetchMemberGenderTypes = () => {
        RestUtilities.get<MemberGenderTypes[]>('/api/MemberGenderTypes')
            .then(resp => {
                let genderTypes: MemberGenderTypes[] = resp.content as MemberGenderTypes[]
                this.setState({ genderTypes: genderTypes })
            })
            .catch(resp => {
                this.showError(resp)
            })
    }

    fetchBmwNumbers = () => {
        RestUtilities.get<BmwEventNumbers[]>('/api/BmwEventNumbers')
            .then(resp => {
                let bmwNumbers: BmwEventNumbers[] = resp.content as BmwEventNumbers[]
                this.setState({ bmwNumbers: bmwNumbers })
            })
            .catch(resp => {
                this.showError(resp)
            })
    }

    fetchEventOptionAvailabilityTypes = () => {
        RestUtilities.get<EventOptionAvailabilityTypes[]>('/api/EventOptionsAvailabilityType')
            .then(resp => {
                let optionTypes = resp.content as EventOptionAvailabilityTypes[]
                this.setState({ eventOptionAvailabilityTypes: optionTypes })
            }).catch(resp => {
                this.showError(resp)
            })
    }

    fetchMemberGroups = () => {
        RestUtilities.get<MemberGroupTypes[]>('/api/MemberGroupTypes?active=true')
            .then(resp => {
                let groupTypes = resp.content as MemberGroupTypes[]
                this.setState({ groupTypes: groupTypes })
            }).catch(resp => {
                this.showError(resp)
            })
    }

    fetchPriceDefinitions = (filter: FilterPriceDefinitions = new FilterPriceDefinitions()) => {

        this.setState({ loading: true })

        let url = '/api/EventPriceDefinitions?'

        if(typeof this.state.event.id !== 'undefined') {
            url += `eventId=${this.state.event.id}&`
        }

        if(typeof filter.memberGroupId !== 'undefined') {
            url += `memberGroupId=${filter.memberGroupId}&`
        }

        if(typeof filter.availabilityTypeId !== 'undefined') {
            url += `availabilityTypeId=${filter.availabilityTypeId}&`
        }

        if(typeof filter.memberAgeGroupId !== 'undefined') {
            url += `memberAgeGroupId=${filter.memberAgeGroupId}&`
        }

        if(typeof filter.eventOptionId !== 'undefined') {
            url += `eventOptionId=${filter.eventOptionId}&`
        }

        if(typeof filter.price !== 'undefined') {
            url += `price=${filter.price}`
        }

        RestUtilities.get<EventPriceDefinitions[]>(url)
            .then(resp => {
                let priceDefinitions = resp.content as EventPriceDefinitions[]
                let priceValues = [...new Set(priceDefinitions.map(x => x.priceValue))]
                if(typeof filter.price !== 'undefined')
                    priceValues = this.state.priceValues

                this.setState({ priceDefinitions: priceDefinitions, priceValues:priceValues, loading: false })
            })
            .catch(resp => {
                this.showError(resp)
            })
    }

    fetchAdditionalPriceDefinitions = (filter: FilterAdditionalPriceDefinitions = new FilterAdditionalPriceDefinitions()): void => {

        this.setState({ loading: true })

        let url = '/api/EventAdditionalPriceDefinitions?'

        if(typeof this.state.event.id !== 'undefined') {
            url += `eventId=${this.state.event.id}&`
        }

        if(typeof filter.memberGroupId !== 'undefined') {
            url += `memberGroupId=${filter.memberGroupId}&`
        }

        if(typeof filter.memberAgeGroupId !== 'undefined') {
            url += `ageGroupId=${filter.memberAgeGroupId}&`
        }

        if(typeof filter.eventAdditionalPriceTypeId !== 'undefined') {
            url += `eventAdditionalPriceTypeId=${filter.eventAdditionalPriceTypeId}&`
        }

        if(typeof filter.price !== 'undefined') {
            url += `price=${filter.price}`
        }

        RestUtilities.get<EventAdditionalPriceDefinitions[]>(url)
            .then(resp => {
                let priceValues = [...new Set(resp.content.map(x => x.priceValue))]
                if(typeof filter.price !== 'undefined')
                    priceValues = this.state.additionalPriceValues

                this.setState({ additionalPriceDefinitions: resp.content, additionalPriceValues: priceValues, loading: false })
            })
            .catch(resp => {
                this.showError(resp)
            })
    }
AgeGroups
    fetchMemberAgeGroups = () => {
        let url = '/api/MemberAgeGroups?active=true'
        if(this.state.event.jahrgang)
            url += '&jahrgang=true'
        else
            url += '&jahrgang=false'
        RestUtilities.get<MemberAgeGroups[]>(url)
            .then(resp => {
                let ageGroups = resp.content as MemberAgeGroups[]
                this.setState({ ageGroups: ageGroups })
            })
            .catch(resp => {
                this.showError(resp)
            })
    }

    fetchEventOptions = () => {
        RestUtilities.get<EventOptions[]>('/api/EventOptions?active=true')
            .then(resp => {
                let eventOptions = resp.content as EventOptions[]
                this.setState({ eventOptions: eventOptions })
            })
            .catch(resp => {
                this.showError(resp)
            })
    }

    fetchEventById = (eventId: number): void => {
        this.setState({ loading: true }, () => {

            RestUtilities.get<EventModel>(`/api/Events?eventId=${eventId}`)
                .then(resp => {
                    this.setState({ event: resp.content, loading: false })
                })
                .catch(resp => {
                    this.showError(resp)
                })
        })
    }

    fetchEventAdditionalPriceTypes = (): void => {
        RestUtilities.get<EventAdditonalPriceTypes[]>('/api/EventAdditonalPriceTypes')
            .then(resp => {
                this.setState({ eventAdditionalPriceTypes: resp.content })
            }).catch(resp => {
                this.showError(resp)
            })
    }

    fetchBookings = (): void => {
        const { event } = this.state
        if (this.eventId !== null && this.eventId !== undefined) {
            this.setState({ loading: true })
            setTimeout(() => {
                RestUtilities.get<Bookings[]>(`/api/Bookings?eventId=${this.eventId}`)
                    .then(resp => {
                        this.setState({ bookings: resp.content, loading: false })
                    }).catch(resp => {
                        this.showError(resp)
                    })
            }, 1000)
        }
    }

    fetchEventCosts = (): void => {
        if (this.eventId !== null && this.eventId !== undefined) {
            RestUtilities.get<EventCosts[]>(`/api/EventCosts?eventId=${this.eventId}`)
                .then(resp => {
                    this.setState({ eventCosts: resp.content })
                }).catch(resp => {
                    this.showError(resp)
                })
        }
    }

    sumbitEvent = (): Promise<any> => {
        if(!this.validateEvent(this.state.event))
            return Promise.resolve(undefined);

        const event = {...this.state.event}
        if(event.memberBirthDateRequired != true)
            event.jahrgang = false
        return RestUtilities.post<EventModel>('/api/Events/Submit', event)
            .then(resp => {
                this.eventId = resp.content.id
                this.setState({ event: resp.content })
                 return Promise.resolve(resp.content);
            })
            .catch(resp => {
                this.showError(resp)
                throw resp.error_content
            })
    }

    editEvent = ():Promise<any>  => {
        if(!this.validateEvent(this.state.event))
            return Promise.resolve(undefined);

        this.setState({ loading:true })

        const event = {...this.state.event}
        if(event.memberBirthDateRequired != true)
            event.jahrgang = false
        return RestUtilities.put<EventModel>('/api/Events/Edit', event)
            .then(resp => {
                this.setState({ event: resp.content })
                 return Promise.resolve(resp.content);
            }).catch(resp => {
                this.showError(resp)
                throw resp.error_content;
            })
    }

    deleteBooking = (id: number): void => {
        this.setState({ loading: true })

        RestUtilities.delete(`/api/Bookings/Delete?id=${id}`)
            .then(() => {
                this.fetchBookings()
                this.setState({ loading: false })
            }).catch(() => {
                this.setState({ loading: false })
            })
    }

    submitPriceDefinition = () => {
        const model = { ...this.state.newPriceDefinition }

        if(!this.validatePriceDefinition(model))
            return

        if (typeof this.state.event.id !== 'undefined') {
            model.eventId = this.state.event.id
        } else {
            console.error("Event is not submitted")
            return
        }

        const { methodPrice } = this.state

        if (methodPrice === 'Edit') {
            model.eventOption = null
            RestUtilities.put<EventPriceDefinitions>(`/api/EventPriceDefinitions/Edit`, model)
                .then(resp => {
                    this.fetchPriceDefinitions();
                    this.setState({ showPriceModal: false, newPriceDefinition: new EventPriceDefinitions() })
                }).catch(resp => {
                    this.showError(resp)
                })
        } else {
            RestUtilities.post<EventPriceDefinitions>(`/api/EventPriceDefinitions/Submit`, model)
                .then(resp => {
                    this.fetchPriceDefinitions();
                    this.setState({ showPriceModal: false, newPriceDefinition: new EventPriceDefinitions() })
                }).catch(resp => {
                    this.showError(resp)
                })
        }
    }

    submitAdditionalPriceDefinition = () => {
        const model = {...this.state.newAdditionalPriceDefinition}

        if(!this.validateAdditionalPriceDefinition(model))
            return

        if(typeof this.state.event.id !== 'undefined') {
            model.eventId = this.state.event.id
        } else {
            console.error('Event is not submitted')
            return
        }

        const { methodAdditionalPrice } = this.state

        if(methodAdditionalPrice === 'Edit') {
            RestUtilities.put<EventAdditionalPriceDefinitions>('/api/EventAdditionalPriceDefinitions/Edit', model)
                .then(resp => {
                    this.fetchAdditionalPriceDefinitions()
                    this.setState({ showOptionsModal: false, newAdditionalPriceDefinition: new EventAdditionalPriceDefinitions() })
                }).catch(resp => {
                    this.showError(resp)
                })
        } else {
            RestUtilities.post<EventAdditionalPriceDefinitions>('/api/EventAdditionalPriceDefinitions/Submit', model)
                .then(resp => {
                    this.fetchAdditionalPriceDefinitions()
                    this.setState({ showOptionsModal: false, newAdditionalPriceDefinition: new EventAdditionalPriceDefinitions() })
                }).catch(resp => {
                    this.showError(resp)
                })
        }
    }

    submitEventCost = (): void => {
        const { newCost } = this.state
        newCost.eventId = this.state.event.id

        if(!this.validateEventCost(newCost))
            return

        if (this.state.methodEventCost === 'Submit') {

            RestUtilities.post<EventCosts>('/api/EventCosts/Submit', newCost)
                .then(() => {
                    this.fetchEventCosts()
                    this.hideCostModal()
                }).catch(resp => {
                    this.showError(resp)
                })
        } else if (this.state.methodEventCost === 'Edit') {
            RestUtilities.put<EventCosts>('/api/EventCosts/Edit', newCost)
                .then(() => {
                    this.fetchEventCosts()
                    this.hideCostModal()
                }).catch(resp => {
                    this.showError(resp)
                })
        }
    }

    deletePriceDefinition = (id:number): void => {
        RestUtilities.delete(`/api/EventPriceDefinitions/Delete?id=${id}`)
            .then(resp => {
                this.fetchPriceDefinitions();
            })
            .catch(resp => {
                this.showError(resp)
            })
    }

    deleteAdditionalPriceDefinition = (id: number): void => {
        RestUtilities.delete(`/api/EventAdditionalPriceDefinitions/Delete?id=${id}`)
            .then(resp => {
                this.fetchAdditionalPriceDefinitions()
            })
            .catch(resp => {
                this.showError(resp)
            })
    }

    deleteEventCost = (id: number) => {
        RestUtilities.delete(`/api/EventCosts/Delete?id=${id}`)
            .then(() => {
                this.fetchEventCosts()
            }).catch(resp => {
                this.showError(resp)
            })
    }

    cancelEvent = (): void => {
        const { emailText, event } = this.state

        RestUtilities.delete(`/api/Events/CancelEvent?id=${event.id}&reason=${emailText}`)
            .then(resp => {
                this.fetchEventById(event.id)
                this.hideEmailModal()
            }).catch(resp => {
                this.showError(resp)
                this.hideEmailModal()
            })
    }

    sendEmail = (): void => {
        const { emailText, event } = this.state

        this.setState({ loading: true })
        
        let formData = {
            eventId: event.id,
            emailText: emailText
        }
        RestUtilities.post('/api/Email/SendEventEmail', formData)
            .then(resp => {
                this.setState({ loading: false })
                this.hideEmailModal()
            }).catch(() => {
                this.hideEmailModal()
            })
    }

    generateInvoice = (): void => {
        this.setState({ loading: true })
        
        let formData = {
            ids: [this.state.event.id]
        }
        RestUtilities.post('/api/Invoices/GenerateInvoice', formData)
            .then(resp => {
                this.setState({ loading: false })
                let response = { error_content: 'Success!' } 
                this.showError(response)
                this.fetchEventById(this.state.event.id)
            }).catch(() => {
                this.setState({ loading: false })
            })
    }

    downloadAttachment = (id: number): void => {
        let url: string = `/api/EventAttachments?id=${id}`
    
    
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    if (xhr.response.size < 200) {
                        let reader = new FileReader()
                        reader.onload = () => {
                            let result = JSON.parse(reader.result as string)
                        }
                        reader.readAsText(this.response)
                        return false
                    }
                    let fileName: string = ''
                    let disposition = xhr.getResponseHeader('Content-Disposition')
    
                    if (disposition != null) {
                        let startIndex = disposition!.indexOf('filename=') + 9
                        fileName = disposition!.substring(21, disposition!.length)
                    }
    
                    let blob = new Blob([this.response])
                    RestUtilities.saveAs(blob, fileName)
    
                }
            }
        }
    
        xhr.open('GET', url)
        xhr.setRequestHeader("Content-type", "application/json")
        xhr.setRequestHeader('Authorization',`Bearer ${Auth.getToken()}`);
        xhr.responseType = 'blob';
        xhr.send()
    }

    deleteAttachment = (id: number) => { 
        RestUtilities.delete(`/api/EventAttachments/Delete?id=${id}`)
            .then(() => {
                this.fetchEventById(this.state.event.id)
            })
    }

    showError = (resp: any): void => {
        if(typeof resp.error_content != 'undefined' && resp.error_content) {
            this.setState({ showError: true, errorMessage: resp.error_content, loading: false })
        }
    }

    showCancelModal = (): void => {
        this.setState({ showCancelModal: true })
    }

    showEmailModal = (): void => {
        this.setState({ showEmailModal: true })
    }

    hideEmailModal = (): void => {
        this.setState({ showEmailModal: false, showCancelModal: false })
    }

    handleChangeEmailText = (event: any):void => {
        this.setState({ emailText: event.target.value })
    } 

    handleSnackbarClose = (event: any, reason: string) => {
        if (reason === 'clickaway')
            return;

        this.setState({ showError:false })
    }

    validateEvent = (event: EventModel): boolean => {
        const requiredFields: any = {...this.state.eventRequiredFields}
        let valid: boolean = true

        Object.keys(requiredFields).map(x => {
            if(event[x] === null || event[x] === undefined || event[x] === '') {
                valid = false
                requiredFields[x] = false
            } else {
                requiredFields[x] = true
             }
        })

        this.setState({ eventRequiredFields: requiredFields })
        return valid
    }

    validatePriceDefinition = (priceDefinition: EventPriceDefinitions): boolean => {
        const requiredFields: any = {...this.state.priceDefRequiredFields}
        let valid: boolean = true

        Object.keys(requiredFields).map(x => {
            if (priceDefinition[x] === null || priceDefinition[x] === undefined || priceDefinition[x] === '') {
                if ((x === 'memberAgeGroupId' && (priceDefinition['newMemberAgeGroupIds'] === undefined || priceDefinition['newMemberAgeGroupIds'].length === 0 )) || 
                (x === 'memberGroupTypeId' && (priceDefinition['newMemberGroupTypeIds'] === undefined || priceDefinition['newMemberGroupTypeIds'].length === 0  )) ||
                (x !== 'memberGroupTypeId' && x !== 'memberAgeGroupId'))  {
                    valid = false
                    requiredFields[x] = false
                }
            } else {
                requiredFields[x] = true
             }
        })

        this.setState({ priceDefRequiredFields: requiredFields })
        return valid
    }

    validateAdditionalPriceDefinition = (additional: EventAdditionalPriceDefinitions): boolean => {
        const requiredFields: any = {...this.state.additionalPriceDefiRequiredFields}
        let valid: boolean = true

        Object.keys(requiredFields).map(x => {
            if(additional[x] === null || additional[x] === undefined || additional[x] === '') {
                valid = false
                requiredFields[x] = false
            } else {
                requiredFields[x] = true
             }
        })

        this.setState({ additionalPriceDefiRequiredFields: requiredFields })
        return valid
    }

    validateEventCost = (eventCost: EventCosts): boolean => {
        const requiredFields: any = {...this.state.eventCostsRequiredFields}
        let valid: boolean = true

        Object.keys(requiredFields).map(x => {
            if(eventCost[x] === null || eventCost[x] === undefined || eventCost[x] === '') {
                valid = false
                requiredFields[x] = false
            } else {
                requiredFields[x] = true
             }
        })

        this.setState({ eventCostsRequiredFields: requiredFields })
        return valid
    }

    exportPricesAndOptions = (): void => {
        let xhr = new XMLHttpRequest();
        let self = this
        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    if (xhr.response.size < 200) {
                        let reader = new FileReader()
                        reader.onload = () => {
                            let result = JSON.parse(reader.result as string)
                        }
                        reader.readAsText(this.response)
                        
                        self.setState({ loading: false })
                        return false
                    }
                    let fileName: string = ''
                    let disposition = xhr.getResponseHeader('Content-Disposition')

                    if (disposition != null) {
                        let startIndex = disposition!.indexOf('filename=') + 9
                        fileName = disposition!.substring(21, disposition!.length)
                    }

                    let blob = new Blob([this.response])
                    
                    let reader = new FileReader()
                    reader.onload = () => {
                        let result = {} as any
                        try {
                            result = JSON.parse(reader.result as string)
                        } catch(ex) {
                            RestUtilities.saveAs(blob, fileName)
                        }

                        if(result.error != null) {
                            self.setState({ loading: false, showMessage: true, message: result.error })
                            return
                        }
                    }

                    reader.readAsText(blob)

                    self.setState({ loading: false })

                }
            }
        }
    
        xhr.open('GET', `/api/Reports/ExportEventPricesAndOptions?eventId=${this.state.event.id}`)
        xhr.setRequestHeader("Content-type", "application/json")
        xhr.setRequestHeader('Authorization',`Bearer ${Auth.getToken()}`);
        xhr.responseType = 'arraybuffer'
        xhr.send()
    }

    componentDidMount() {

        if(this.eventId !== null && this.eventId !== undefined)
            this.fetchEventById(this.eventId)

        this.fetchMemberGroups()
        this.fetchEventStatuses()
        this.fetchMemberGenderTypes()
        this.fetchBmwNumbers()
        this.fetchEventOptionAvailabilityTypes()

        const params = new URLSearchParams(this.props.router.location.search)
        const step = params.get('step')
        if(typeof step != 'undefined' && step != null)
            this.setState({ activeStep: parseInt(step) })
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.router.location.search !== prevProps.router.location.search && this.props.router.location.search !== '') {
            const params = new URLSearchParams(this.props.location.search)
            const value = params.get('eventid')

            this.fetchEventById(parseInt(value))

        } else if (this.props.router.location.search !== prevProps.router.location.search && this.props.router.location.search === '') {
            this.setState({ event: new EventModel(), activeStep: 0 })
        }
    }

    public render() {
        const { activeStep } = this.state
        const steps: any[] = this.getSteps()
        return (
            <>
                {this.state.loading && <Loader />}
                <h2 className='title'>{`Veranstaltung ${this.state.event.eventName}`}</h2>
                <Stepper alternativeLabel nonLinear activeStep={activeStep}>
                    {steps.map((label, index) => {
                        const props = {};
                        const buttonProps = {};
                        return (
                            <Step key={label} {...props}>
                                <StepButton
                                    onClick={() => this.handleStep(index)}
                                    //completed={this.isStepComplete(index)}
                                    {...buttonProps}
                                >
                                    <Box sx={{ display: { xs: 'block', sm: 'none' } }} >{label}</Box>
                                </StepButton>
                            </Step>
                        );
                    })}
                </Stepper>
                <div className='row mb-4 saveButton'>
                    <div>
                        {
                            activeStep !== 0 &&
                            <Button
                                onClick={this.handleBack}
                                color="secondary" 
                                className='mr-2 btnBlue'>
                                Zurück
                            </Button>
                        }
                        <Button 
                            className='btnBlue' 
                            variant="contained" 
                            color="primary" 
                            onClick={this.handleNext} 
                            disabled={this.state.saveButtonDisabled}
                        >
                            {activeStep === steps.length - 1 ? 'Speichern & Abschließen' : 'Speichern & Weiter'}
                        </Button>
                    </div>
                </div>
                <div className='mb-4'>
                    {this.getStepContent(activeStep)}
                </div>
                <GrowMessage
                        anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                        }}
                        message={this.state.errorMessage}
                        visible={this.state.showError}
                        autoHideDuration={6000}
                        onClose={this.handleSnackbarClose}
                    ></GrowMessage>  
                {
                    this.state.showCancelModal &&
                    <EmailModal 
                        reason='cancel' 
                        value={this.state.emailText}
                        change={this.handleChangeEmailText}
                        hide={this.hideEmailModal}
                        submit={this.cancelEvent}
                        />
                }
                 {
                    this.state.showEmailModal &&
                    <EmailModal 
                        reason='email' 
                        value={this.state.emailText}
                        change={this.handleChangeEmailText}
                        hide={this.hideEmailModal}
                        submit={this.sendEmail}
                        />
                }
            </>
        )
    }
}
export default withRouter(EditEvent);